import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, Grid, CardHeader, Button, TextField, FormControl, FormControlLabel, FormHelperText, Checkbox, Typography, Link, useForkRef } from '@material-ui/core';
import ReactHtmlParser from 'react-html-parser';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import MaskedInput from 'react-text-mask';

import { Autocomplete } from '@material-ui/lab';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import ProcessingBox from './ProcessingBox';
import PaymentCompletebox from './PaymentCompletebox';

import {
    actionShopCartResetState, actionShopCartResetStateWithUniqueCouponHold, actionResetFormErrorState, actionSetFormErrorState, actionSetFieldValueState,
    actionShopCartRemoveGiftcards, actionShopCartApplyMembershipOnEvents, actionShopCartResetMembership, actionShopCartResetIDME,
    actionShopCartUpdateMembershipEmail, actionShopCartResetMembershipPackage, actionShopCartApplyidmeCostratesOnEvents,
    actionShopCartValidMember, actionShopCartShowTransFee, actionResetCustomerAddresses, actionResetCustomer, actionEndMemberValidationLoading, actionResetPaymentTransaction,
    actionGetMemberValidation, actionResetMemberValidation, actionGetExtraItems, actionResetExtraItems, actionGetCostRate, actionResetCostRate,
    actionGetIDMEUSERDATA, actionResetIDMEUSERDATA, actionGetCountryAndState, actionResetCountryAndState, actionValidateRecaptchaToken, actionValidateRecaptchaReset,
    actionResetGiftCards, actionResetMembershipPackages, actionGetDonation, actionResetUDFs, actionResetMembershipUDFs
} from 'actions';

import ErrorHandling from '../../../components/ErrorHandling/ErrorHandling';
import DialogeBox from '../../../components/DialogeBox/DialogeBox';
import { genfunction } from 'helpers'
import { formstates } from '../';
import FreeTicketForm from '../components/FreeTicketForm';
import CryptoAES from 'crypto-js/aes'
import CryptoENC from 'crypto-js/enc-utf8';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { actionStartAppLoader, actionEndAppLoader } from '../../../actions/actionAppLoader';
import Payments from '../../../components/Payments/Payments';
import { actionResetCustomerUdfs } from 'actions';
import MultiPayments from './MultiPayments';
import { useDebouncedCallback } from 'use-debounce';
import { actionStopUserToPurchase } from 'actions';


const { forwardRef, useRef, useImperativeHandle } = React;

const { RedirectAfterCheckout, Titleforloadingpayment, Subtitle1forloadingpayment, Subtitle2forloadingpayment,
    EmailRegex, DefaultCostRateID, MembershipCostRateMatches, CouponAndGiftcardAlreadyApplied, Membershipsuccess,
    HideMemberValidation, UserMembershipValidatedEmailAndLastName, RemoveMembershipCouponAndGiftcard, TermsnConditionCheckBoxText, TermsnConditionCheckMsg,
    RemoveMembershipsuccess, IamMember, LastNameAndEmailORPhoneORAddressForMembership, RequiredEmailORPhoneORAddressForMembership,
    PaymentFormHeading, UseStreetAddressForAVS, RecaptchaV3Client, ShowFullAddressOnCheckout,
    CheckForIDmeValidProducts, IDmeAPIurl, IDmeClientID, IDmeRedirectURI, IDmeResponseType, IDmeScope, IDmeHeading, IDmeSuccessMsg,
    IDmeInvalidGroup, IDmeResponseTypeError, IDmeInvalidClient, IDmeInvalidRedirectUri, IDmeAccessDenied, AddPersonZipCodeLength,
    AddPersonCityLength, AddPersonAddress1Length, AddPersonAddress2Length, AddPersonEmailLength,
    AddPersonFirstNameLength, AddPersonLastNameLength, PaymentMethodType, PhoneNumberMandatory, ValidMemberMsg, ApplyTransactionFee, EnableAlternateMerchantOnline,
    PhoneNumberMessage } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    primarycolor: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    box100per: {
        width: "100%"
    },
    iconforiframe: {
        marginTop: "18px"
    },
    iframebox: {
        marginTop: "-13px",
        height: "31px"
    },
    hidden: {
        visibility: "hidden"
    },
    displaynone: {
        display: "none"
    },
    visible: {
        visibility: "visible"
    },
    btnAlign: {
        marginTop: '10px'
    },
    imMember: {
        marginTop: '15px'
    },
    clearButton: {
        "& .MuiButtonBase-root.MuiAutocomplete-clearIndicator": {
            color: theme.palette.primary.main
        }
    }
}));

function TextMaskCustom(props) {
    const { inputRef, onChange, value, ...other } = props;
    let pnMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    return (
        <MaskedInput
            value={value}
            {...other}
            ref={(ref) => {
                inputRef(ref ? ref.inputElement : null);
            }}
            onChange={onChange}
            mask={pnMask}
        />
    );
}

let PaymentForm = forwardRef((props, ref) => {

    const paymentsRef = useRef();
    const classes = useStyles();
    const [pfstate, setpfstate] = useState(formstates.initialpaystate);
    //const [errorstate, seterrorstate] = useState(formstates.initialerrorstate)
    const dispatch = useDispatch();
    const { executeRecaptcha } = useGoogleReCaptcha();


    useImperativeHandle(ref, () => ({
        ReloadGateways() {
            ReloadGateway();
        }
    }));

    const events = useSelector(state => state.reducerShopCart.events);
    const cashless = useSelector(state => state.reducerShopCart.cashless);
    const errorstate = useSelector(state => state.reducerFormError.errorstate);
    const formfields = useSelector(state => state.reducerFormError.formfields);
    const transactionfee = useSelector(state => state.reducerTransactionFee);
    const membershipPackages = useSelector(state => state.reducerShopCart.MembershipPackages);
    const gatickets = useSelector(state => state.reducerShopCart.GATickets);
    const orderProducts = useSelector(state => state.reducerShopCart.orderProducts);
    const giftcards = useSelector(state => state.reducerGiftCards);
    const costrate = useSelector(state => state.reducerCostRate);
    const idmeuserdata = useSelector(state => state.reducerIDMeUserData);
    const bookingUDFS = useSelector(state => state.reducerBookingUserDefinedFields);
    const membershipTypesUdfs = useSelector(state => state.reducerMembershipUserDefinedFields);
    const countryandstates = useSelector(state => state.reducerCountryAndState.countryandstate);
    const customerUdfs = useSelector(state => state.reducerCustomerUDFs);
    const showTransFee = useSelector(state => state.reducerShopCart.showTransactionFee);
    const bookingTypes = useSelector(state => state.reducerBookingTypes.bookingTypes);
    const donationProducts = useSelector(state => state.reducerShopCart.donationProducts);
    const recaptacha = useSelector(state => state.reducerRecaptcha);
    const sessionID = useSelector(state => state.reducerGlobal.sessionID);
    const stopUserToPurchase = useSelector(state => state.reducerGlobal.stopUserToPurchase);
    const customerAddresses = useSelector(state => state.reducerCustomerAddresses.customerAddresses);
    const customer = useSelector(state => state.reducerCustomer);

    const [errorMsg, seterrorMsg] = useState("");
    const [opentnc, setopentnc] = useState(false);
    const [tncchecked, settncChecked] = React.useState(false);
    const [colorState, setColorState] = React.useState('');
    const [removeMembershipState, setremoveMembershipState] = React.useState(false);
    const [removemembershipcouponandgifts, setremovemembershipcouponandgifts] = React.useState(false);

    var requiredFields = {};
    let inputreferences = [];

    inputreferences.first_name = React.useRef();
    inputreferences.last_name = React.useRef();
    inputreferences.email = React.useRef();
    inputreferences.phone_number = React.useRef();
    inputreferences.address1 = React.useRef();
    inputreferences.country = React.useRef();
    inputreferences.state = React.useRef();
    inputreferences.city = React.useRef();
    inputreferences.zip = React.useRef();
    inputreferences.memberno = React.useRef();
    inputreferences.shipping_phone_number = React.useRef();
    inputreferences.shipping_address1 = React.useRef();
    inputreferences.shipping_city = React.useRef();
    inputreferences.shipping_state = React.useRef();
    inputreferences.shipping_zip = React.useRef();
    inputreferences.shipping_country = React.useRef();

    const paymenttranstate = useSelector(state => {
        return (
            {
                loading: state.reducerPaymentTransaction.loading,
                haspaid: state.reducerPaymentTransaction.Payment.hasOwnProperty('Products'),
                paymentinfo: state.reducerPaymentTransaction.Payment,
                errormsg: state.reducerPaymentTransaction.PaymentInfoError
            }
        )

    });

    const ShowGiftCards = () => {
        let res = false;
        if (giftcards.giftcards && giftcards.giftcards.length > 0) {
            if (giftcards.giftcards.filter(x => x.AddedToCart === true).length > 0) {
                res = true;
            }
        }

        return res;
    }

    useEffect(() => {
        if (paymenttranstate.haspaid) {
            actionResetMemberValidation(dispatch);
            setTimeout(() => { window.scrollTo(0, 0) }, 0);

        }
    }, [paymenttranstate.haspaid])

    useEffect(() => {

        if (transactionfee.transactionFee && transactionfee.transactionFee.length > 0) {
            if (transactionfee.transactionFee[0].TransactionFeeByDefault) {
                actionShopCartShowTransFee(dispatch, true);
            }
        }

    }, [transactionfee])

    const handleReCaptchaVerify = useCallback(async () => {

        if (!executeRecaptcha) {
            console.log('Execute recaptcha not yet available.');
            return;
        }

        let token = await executeRecaptcha('ecommerce');

        if (token.length > 0) {
            actionValidateRecaptchaToken(dispatch, token, sessionID);
        }
        else {
            seterrorMsg("Recaptcha token not fetched.");
        }

    }, [executeRecaptcha]);

    useEffect(() => {

        if ((events && events.length > 0) || (gatickets && gatickets.length > 0) ||
            (membershipPackages && membershipPackages.length > 0) || ShowGiftCards() ||
            (orderProducts && orderProducts.length > 0) || (donationProducts && donationProducts.length > 0)) {

            if (RecaptchaV3Client && RecaptchaV3Client != '' && (stopUserToPurchase !== undefined
                && stopUserToPurchase === false) && (sessionID !== undefined && sessionID.length > 0)
                && (recaptacha.validToken !== undefined && recaptacha.validToken === false)) {

                handleReCaptchaVerify();
            }

            if (recaptacha.validTokenError.length > 0) {
                seterrorMsg(recaptacha.validTokenError);
            }
        }

    }, [handleReCaptchaVerify, RecaptchaV3Client, stopUserToPurchase, sessionID, recaptacha.validToken])

    useEffect(() => {
        if (paymenttranstate.errormsg.includes("Payment has been unsuccessful. To make this purchase, please contact us directly.")) {
            actionStopUserToPurchase(dispatch);
        }
    }, [paymenttranstate.errormsg]);



    useEffect(() => {
        if (recaptacha.validTokenError.length > 0) {
            seterrorMsg(recaptacha.validTokenError);

            if (recaptacha.validTokenError.includes('Too many attempts detected from this IP, Email and Browser Session.')) {
                actionStopUserToPurchase(dispatch);
            }
        }

    }, [recaptacha.validTokenError]);

    useEffect(() => {
        if ((events.length > 0 || membershipPackages.length > 0 || gatickets.length > 0 || orderProducts.length > 0 || ShowGiftCards() || (donationProducts && donationProducts.length > 0)) && paymenttranstate.haspaid) {
            actionShopCartResetState(dispatch);
            if (bookingUDFS.bookingUDFs.length > 0) {
                actionResetUDFs(dispatch);
            }

            actionValidateRecaptchaReset(dispatch);

        }

        if (ShowGiftCards() === true && paymenttranstate.haspaid) {
            actionResetGiftCards(dispatch);
        }

    })

    useEffect(() => {

        if (paymenttranstate.haspaid) {
            if (membershipTypesUdfs.membershipUdfs && membershipTypesUdfs.membershipUdfs.length > 0) {
                actionResetMembershipUDFs(dispatch);
            }

            if (customerUdfs.customerUDFs && customerUdfs.customerUDFs.length > 0) {
                actionResetCustomerUdfs(dispatch);
            }
        }


    }, [paymenttranstate.haspaid])


    useEffect(() => {

        if ((events.length > 0 || membershipPackages.length > 0 || gatickets.length > 0 || orderProducts.length > 0 || ShowGiftCards() || (donationProducts && donationProducts.length > 0)) && tncchecked) {
            setpfstate({
                ...pfstate,
                disablepay: false
            })
        }
        else if (pfstate.disablepay == false) {
            setpfstate({
                ...pfstate,
                disablepay: true
            })
        }

        let btnStatus = document.getElementById("btnApplyMembership");

        if (formfields.checkBoxMember.value === true &&
            btnStatus.name !== "Remove" &&
            removeMembershipState === false) {
            setpfstate({
                ...pfstate,
                disablepay: true
            })
        }

    }, [events, tncchecked, formfields])


    const getTNC = () => {
        return ReactHtmlParser(TermsnConditionCheckMsg);
    }

    const tnccheckeHandle = (event) => {
        settncChecked(event.target.checked);
    };

    const transFeeCheckHandler = (event) => {
        actionShopCartShowTransFee(dispatch, event.target.checked);
    };

    const transFeeCheckBox = () => {

        let showTFBox = true;

        if (transactionfee.transactionFee && transactionfee.transactionFee.length > 0) {
            if (transactionfee.transactionFee[0].TransactionFeeOptional === false && transactionfee.transactionFee[0].TransactionFeeByDefault === false) {
                showTFBox = false;
                if (!showTransFee && ApplyTransactionFee) {
                    actionShopCartShowTransFee(dispatch, true);
                }
            }
        }

        return showTFBox;
    };

    const filterOptions = createFilterOptions({
        stringify: (option) => option.Country + '' + option.State,
    });

    const errorcancelhandle = () => {
        actionResetPaymentTransaction(dispatch);

        seterrorMsg("");

        if (colorState !== 'info') {
            actionResetIDMEUSERDATA(dispatch);
            actionResetCostRate(dispatch);
        }
    }

    const onClickPaymentHandler = () => {

        actionResetPaymentTransaction(dispatch);
        actionShopCartResetMembership(dispatch);
        actionShopCartResetIDME(dispatch);
        actionResetMemberValidation(dispatch);
        actionShopCartResetMembershipPackage(dispatch);
        actionResetExtraItems(dispatch);
        actionGetDonation(dispatch);
        actionResetMembershipPackages(dispatch);
        actionResetCostRate(dispatch);
        actionResetCountryAndState(dispatch);

        if (idmeuserdata && idmeuserdata.userdata) {
            actionResetIDMEUSERDATA(dispatch);
        }

        if (bookingUDFS.bookingUDFs.length > 0) {
            actionResetUDFs(dispatch);
        }

        if (membershipTypesUdfs.membershipUdfs && membershipTypesUdfs.membershipUdfs.length > 0) {
            actionResetMembershipUDFs(dispatch);
        }

        if (customerUdfs.customerUDFs && customerUdfs.customerUDFs.length > 0) {
            actionResetCustomerUdfs(dispatch);
        }

        if (customerAddresses && customerAddresses.length > 0) {
            actionResetCustomerAddresses(dispatch);
        }

        if (customer.customer && customer.customer.length > 0) {
            actionResetCustomer(dispatch);
        }

        ReloadGateway();

        window.location.href = RedirectAfterCheckout;
    }


    const ReloadGateway = () => {
        if (PaymentMethodType === "Spreedly") {
            paymentsRef.current.ReloadSpreedly();
        }
        else {
            paymentsRef.current.GPReload();
        }
    }

    const reseterrorfield = () => {
        actionResetFormErrorState(dispatch);
    }

    const errorfield = (errorfield, errortext, errorstate) => {
        actionSetFormErrorState(dispatch, errorfield, errortext, errorstate)
    }

    const checkfieldvalidation = (fields) => {
        for (let prop in fields) {
            if (fields[prop] == "") {
                if (prop === 'phone_number') {
                    errorfield(prop, PhoneNumberMessage, true);
                }
                else {
                    errorfield(prop, prop + " is required.", true);
                }

                inputreferences[prop].current.focus();
                window.scrollBy(0, -65);
                return false
            }
            else {
                errorfield(prop, "", false)
            }
        }
        return true;
    }

    const ValidateQuanity = () => {

        let isvalid = true;
        events.forEach(event => {

            if (genfunction.IsEditEvent(bookingTypes, event))
                return;

            let MinTicket = event.TourProducts[0].MinimumTickets;

            let fproduct = event.TourProducts.filter(p => p.AffectsCapacity);
            let consumedQty = 0;
            if (fproduct && fproduct.length > 0) {
                consumedQty = fproduct.reduce((a, b) => {
                    let aqty = a.Quantity === undefined ? 0 : a.Quantity;
                    let bqty = b.Quantity === undefined ? 0 : b.Quantity;
                    let newobj = { Quantity: aqty + bqty }
                    return newobj;
                }).Quantity;
            }

            if (consumedQty < MinTicket) {
                seterrorMsg("Minimum tickets for event is " + MinTicket + ", please add more tickets.")
                isvalid = false;
            }
        });

        return isvalid;
    }

    const billingAddressSameAsAbover = () => {

        if (formfields.billingAddressSame.value) {
            formfields.shipping_address1.value = formfields.address1.value;
            formfields.shipping_address2.value = formfields.address2.value;
            formfields.shipping_city.value = formfields.city.value;
            formfields.shipping_state.value = formfields.state.value;
            formfields.shipping_zip.value = formfields.zip.value;
            formfields.shipping_country.value = formfields.country.value;
            formfields.shipping_phone_number.value = formfields.phone_number.value;
        }
    }

    const BindRequiredFields = () => {

        requiredFields = {};

        if (PhoneNumberMandatory || (orderProducts && orderProducts.length > 0)) {
            requiredFields["phone_number"] = formfields.phone_number.value.trim();
            requiredFields["shipping_phone_number"] = formfields.shipping_phone_number.value;
        }

        requiredFields["email"] = formfields.email.value.trim();
        if (UseStreetAddressForAVS)
            requiredFields["address1"] = formfields.address1.value;
        requiredFields["country"] = formfields.country.value;
        requiredFields["city"] = formfields.city.value;

        if (isShowCountryFields("ShowState")) {
            requiredFields["state"] = formfields.state.value;
        }
        else {
            formfields.state.value = "0";
        }

        if (isShowCountryFields("ShowPostalCode")) {
            if (formfields.zip.value.length > 5)
                requiredFields["zip"] = formfields.zip.value.substring(0, 5);
            else
                requiredFields["zip"] = formfields.zip.value;
        }
        else {
            formfields.zip.value = "0";
        }

        requiredFields["first_name"] = formfields.first_name.value;
        requiredFields["last_name"] = formfields.last_name.value;

        requiredFields["shipping_address1"] = formfields.shipping_address1.value;
        requiredFields["shipping_city"] = formfields.shipping_city.value;

        if (isShowShippingCountryFields("ShowState")) {
            requiredFields["shipping_state"] = formfields.shipping_state.value;
        }
        else {
            formfields.shipping_state.value = "0";
        }

        if (isShowShippingCountryFields("ShowPostalCode")) {
            requiredFields["shipping_zip"] = formfields.shipping_zip.value;
        }
        else {
            formfields.shipping_zip.value = "0";
        }

        requiredFields["shipping_country"] = formfields.shipping_country.value;

        if (ShowFullAddressOnCheckout == false) {
            requiredFields["address1"] = requiredFields["country"] = requiredFields["city"] = requiredFields["state"] = undefined;
            requiredFields["shipping_address1"] = requiredFields["shipping_country"] = requiredFields["shipping_city"] = requiredFields["shipping_state"] = undefined;
        }

        if (checkfieldvalidation(requiredFields) == false) { return; }
        if (validateEmail(requiredFields["email"]) == false) {
            errorfield("email", "Please enter a valid email address", true);
            inputreferences['email'].current.focus();
            window.scrollBy(0, -65);
            return;
        }
        else if (requiredFields["phone_number"] && validatePhoneNum(requiredFields["phone_number"]) == false) {
            errorfield("phone_number", "Please enter a valid phone #", true);
            inputreferences['phone_number'].current.focus();
            window.scrollBy(0, -65);
            return;
        }
        else if (requiredFields["shipping_phone_number"] && validatePhoneNum(requiredFields["shipping_phone_number"]) == false) {
            errorfield("shipping_phone_number", "Please enter a valid phone #", true);
            inputreferences['shipping_phone_number'].current.focus();
            window.scrollBy(0, -65);
            return;
        }
        else {

            if (PhoneNumberMandatory || (orderProducts && orderProducts.length == 0)) {
                requiredFields["phone_number"] = formfields.phone_number.value;
                requiredFields["shipping_phone_number"] = formfields.shipping_phone_number.value;
            }

            requiredFields["address2"] = formfields.address2.value;
            requiredFields["shipping_address2"] = formfields.shipping_address2.value;

            if (shopcartreducer.membershipValidation.ismembershipApplied &&
                ((shopcartreducer.membershipValidation.memberEmail.length > 0 && shopcartreducer.membershipValidation.memberEmail !== formfields.email.value)
                    || (shopcartreducer.membershipValidation.memberLastName.length > 0 && shopcartreducer.membershipValidation.memberLastName !== formfields.last_name.value))) {
                setColorState('');
                seterrorMsg(UserMembershipValidatedEmailAndLastName);
                return;
            }
        }

        return requiredFields;
    }

    const ValidatePaymentFields = () => {
        setColorState('');

        if (ValidateQuanity() == false)
            return;

        billingAddressSameAsAbover();

        reseterrorfield();

        requiredFields = BindRequiredFields();

        return requiredFields ? true : false;
    }

    const submitPaymentForm = () => {

        if (ValidatePaymentFields()) {

            if (genfunction.subproducttotal(events, cashless, donation, (showTransFee ? transactionfee.transactionFee[0] : null), membershipPackages, gatickets, giftcards.giftcards, orderProducts, donationProducts) > 0) {
                requiredFields["month"] = formfields.MonthSelect.value;
                requiredFields["year"] = formfields.YearSelect.value;
                //reseterrorfield();
                paymentsRef.current.SpreedlyTransactionCall(requiredFields);
            }
            else {
                paymentsRef.current.SpreedlyZeroDollarTransactionCall(requiredFields);
            }
        }
    }

    const onClickPayBtn = useDebouncedCallback(submitPaymentForm, 5000, { leading: true });


    function validateEmail(email) {
        var re = new RegExp(EmailRegex);
        return re.test(String(email).toLowerCase());
    }

    function validatePhoneNum(phoneNum) {
        let cusNumber = phoneNum.replace(/\D/g, "");
        if (cusNumber != "" && cusNumber.length < 10) {
            return false;
        }
        return true;
    }

    const fieldhandleChange = (event) => {
        if (event.currentTarget.name === "checkBoxMember")
            actionSetFieldValueState(dispatch, event.currentTarget.name, event.target.checked);
        else
            actionSetFieldValueState(dispatch, event.currentTarget.name, event.target.value);

    };

    const onChangeCountry = (event, value) => {
        actionSetFieldValueState(dispatch, "country", value === null ? "" : value.Country);
        onChangeState(event, null);
    }

    const onChangeState = (event, value) => {
        actionSetFieldValueState(dispatch, "state", value === null ? "" : value.State);

    }

    const onChangeShippingCountry = (event, value) => {
        if (value === null) {
            actionSetFieldValueState(dispatch, "shipping_country", "")
            actionSetFieldValueState(dispatch, "shipping_state", "")
        }
        else
            actionSetFieldValueState(dispatch, "shipping_country", value.Country);

        onChangeShippingState(event, null);

    }
    const onChangeShippingState = (event, value) => {
        actionSetFieldValueState(dispatch, "shipping_state", value === null ? "" : value.State);

    }
    useEffect(() => {
        actionGetCountryAndState(dispatch);
    }, [])

    useEffect(() => {
        if (countryandstates && countryandstates.length > 0) {
            if (formfields.country.value == "")
                actionSetFieldValueState(dispatch, "country", countryandstates[0].Country);
            if (formfields.shipping_country.value == "") {
                actionSetFieldValueState(dispatch, "shipping_country", countryandstates[0].Country);
            }
        }
    }, [countryandstates]);

    const isShowCountryFields = (columnName) => {
        return genfunction.GetValueFromCountryAndState(countryandstates, formfields.country.value, columnName);

    }

    const isShowShippingCountryFields = (columnName) => {
        return genfunction.GetValueFromCountryAndState(countryandstates, formfields.shipping_country.value, columnName);
    }

    const openerrorpopup = () => {
        return (paymenttranstate.errormsg != "" || errorMsg != "")
    }

    //Membership Validation

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleCloseDialog = (event) => {
        actionSetFieldValueState(dispatch, "email", event.currentTarget.name);
        actionShopCartUpdateMembershipEmail(dispatch, event.currentTarget.name);
        setOpen(false);
    };

    const memberValidationReducer = useSelector(state => state.reducerMemberValidation);
    const shopcartreducer = useSelector(state => state.reducerShopCart);
    const tourEvents = useSelector(state => state.reducerExtraItems.extramItems);
    const donation = useSelector(state => state.reducerShopCart.donation);

    useEffect(() => {
        if (memberValidationReducer.loading)
            actionStartAppLoader(dispatch)
        else
            actionEndAppLoader(dispatch);
    }, [memberValidationReducer.loading]);


    useEffect(() => {
        if (memberValidationReducer && (shopcartreducer.membershipValidation.ismembershipApplied === false)) {
            if (memberValidationReducer.membervalidationError && memberValidationReducer.membervalidationError.length > 0) {

                setColorState('');
                seterrorMsg(memberValidationReducer.membervalidationError);
            }

            if (memberValidationReducer.membervalidation && memberValidationReducer.membervalidation.MemberValidation !== undefined) {

                if (!genfunction.ValidateMemberValidate(memberValidationReducer.membervalidation.MemberValidation[0])) {
                    seterrorMsg(LastNameAndEmailORPhoneORAddressForMembership);
                    actionResetMemberValidation(dispatch);
                    return;
                }

                if (events && events.length > 0) {

                    if (memberValidationReducer.membervalidation.MemberValidation[0].hasOwnProperty('AlertMessage')
                    ) {
                        setColorState('info');
                        seterrorMsg(memberValidationReducer.membervalidation.MemberValidation[0].AlertMessage);
                        actionSetFieldValueState(dispatch, "memberno", "");
                        actionResetMemberValidation(dispatch);

                        return;
                    }

                    if (memberValidationReducer.membervalidation.MemberValidation[0].hasOwnProperty('CostRateID')) {
                        if (DefaultCostRateID == memberValidationReducer.membervalidation.MemberValidation[0].CostRateID) {
                            setColorState('info');
                            seterrorMsg(MembershipCostRateMatches)
                            actionSetFieldValueState(dispatch, "memberno", "");
                            actionResetMemberValidation(dispatch);
                            return;
                        }

                        if (DefaultCostRateID != memberValidationReducer.membervalidation.MemberValidation[0].CostRateID) {
                            if (shopcartreducer.cashless.length > 0 || shopcartreducer.tourCoupons.length > 0) {
                                RemoveCouponsAndGiftCards();
                            }

                            GetTourEvents();
                        }
                    }

                }
                else if ((membershipPackages && membershipPackages.length > 0) || (gatickets && gatickets.length > 0) || ShowGiftCards() || (orderProducts && orderProducts.length > 0) || (donationProducts && donationProducts.length > 0)) {
                    setColorState('info');
                    seterrorMsg(ValidMemberMsg);

                    actionShopCartValidMember(dispatch,
                        memberValidationReducer.membervalidation.MemberValidation[0].CostRateID,
                        formfields.memberno.value,
                        formfields.email.value,
                        formfields.last_name.value);
                }
            }
        }
        else {
            if (memberValidationReducer.membervalidation !== undefined && memberValidationReducer.membervalidation.MemberValidation !== undefined && memberValidationReducer.loading) {
                actionEndMemberValidationLoading(dispatch);
            }
        }
    }, [memberValidationReducer]);

    useEffect(() => {
        if ((shopcartreducer.IDME.isIdMeApplied || shopcartreducer.membershipValidation.ismembershipApplied) && removeMembershipState === false) {
            if (genfunction.IsOrganization(events)) {
                setremoveMembershipState(true);
                actionResetMemberValidation(dispatch);

                if (events && events.length > 0) {
                    RemoveCouponsAndGiftCards();
                    GetTourEvents();
                }
                else if ((membershipPackages && membershipPackages.length > 0) || (gatickets && gatickets.length > 0) || ShowGiftCards() || (orderProducts && orderProducts.length > 0) || (donationProducts && donationProducts.length > 0)) {
                    RemoveMembership();
                }
            }
        }
    }, [events])

    useEffect(() => {

        if (memberValidationReducer.membervalidation &&
            memberValidationReducer.membervalidation.MemberValidation !== undefined
            && (shopcartreducer.membershipValidation.ismembershipApplied === false) && events.length > 0 && formfields.checkBoxMember.value == true) {

            actionShopCartApplyMembershipOnEvents(dispatch, memberValidationReducer.membervalidation.MemberValidation[0].CostRateID, tourEvents, formfields.memberno.value, formfields.email.value, formfields.last_name.value);

            if (memberValidationReducer.membervalidation.MemberValidation[0].EmailMatched == false
                && document.getElementById('Email').value !== memberValidationReducer.membervalidation.MemberValidation[0].EmailOnFile) {
                handleClickOpen();
            }

            if (removemembershipcouponandgifts) {
                setColorState('info');
                seterrorMsg(CouponAndGiftcardAlreadyApplied);
            }
            else {
                if (colorState !== 'info') {
                    setColorState('info');
                    seterrorMsg(Membershipsuccess);

                    if (idmeuserdata && idmeuserdata.userdata.hasOwnProperty('attributes') && idmeuserdata.userdataerror.length < 1) {
                        actionResetCostRate(dispatch);
                        actionResetIDMEUSERDATA(dispatch);
                    }
                }
            }
        }

        let btnStatus = document.getElementById("btnApplyMembership");

        if (btnStatus && btnStatus.name === "Remove" && removeMembershipState) {

            actionShopCartApplyMembershipOnEvents(dispatch, DefaultCostRateID, tourEvents, 0, "", "");
            RemoveMembership();
        }
        else if (genfunction.IsOrganization(events) && shopcartreducer.IDME.isIdMeApplied && removeMembershipState) {

            actionShopCartApplyidmeCostratesOnEvents(dispatch, DefaultCostRateID, tourEvents);
            RemoveMembership();
        }
    }, [tourEvents]);

    useEffect(() => {
        genfunction.CalculateAmountSelectedForMembers(events, bookingTypes);

    }, [tourEvents, events])

    const RemoveMembership = () => {

        actionShopCartResetMembership(dispatch);
        actionShopCartResetIDME(dispatch);
        actionEndMemberValidationLoading(dispatch);
        actionSetFieldValueState(dispatch, "memberno", "");
        actionSetFieldValueState(dispatch, "checkBoxMember", false);

        setColorState('info');

        if (removemembershipcouponandgifts)
            seterrorMsg(RemoveMembershipCouponAndGiftcard)
        else
            seterrorMsg(RemoveMembershipsuccess)

        setremoveMembershipState(false);

    }

    const GetTourEvents = () => {

        let eventslist = genfunction.GetTourEventsList(events);
        actionGetExtraItems(dispatch, null, null, null, null, null, null, eventslist);
    }

    const RemoveCouponsAndGiftCards = () => {

        if (shopcartreducer.cashless.length > 0) {
            actionShopCartRemoveGiftcards(dispatch);
            setremovemembershipcouponandgifts(true);
        }

        if (shopcartreducer.tourCoupons.length > 0) {
            actionShopCartResetStateWithUniqueCouponHold(dispatch);
            setremovemembershipcouponandgifts(true);
        }
    }

    const MemberValidation = (memberno) => {

        errorcancelhandle();
        setColorState('');
        setremovemembershipcouponandgifts(false);

        var requiredFields1 = {};
        requiredFields1["memberno"] = document.getElementById("memberno").value;
        requiredFields1["last_name"] = document.getElementById("Lname").value;
        var email = document.getElementById("Email").value.trim();
        var phone = document.getElementById("phone_number").value;
        var address = '';

        if ((ShowFullAddressOnCheckout)) {
            address = document.getElementById("address1").value;
        }
        var buttonState = document.getElementById("btnApplyMembership").name;

        if (buttonState === "Apply") {

            if (checkfieldvalidation(requiredFields1) == false) { return; }

            if (email.length < 1 && phone.length < 1 && address.length < 1) {
                seterrorMsg(RequiredEmailORPhoneORAddressForMembership);
                return;
            }

            if (email.length > 0 && validateEmail(email) == false) {
                errorfield("email", "Please enter a valid email address", true);
                inputreferences['email'].current.focus();
                window.scrollBy(0, -65);
                return;
            }

            if (memberno.trim().length > 1) {

                if (memberValidationReducer.membervalidation &&
                    memberValidationReducer.membervalidation.MemberValidation !== undefined) {
                    actionResetMemberValidation(dispatch);
                }

                if (events && events.length > 0) {
                    let latestDate = genfunction.GetLatestTourEvent(events);
                    actionGetMemberValidation(dispatch, memberno, requiredFields1["last_name"], email, phone, address, latestDate);
                }
                else if ((membershipPackages && membershipPackages.length > 0) || (gatickets && gatickets.length > 0) || ShowGiftCards() || (orderProducts && orderProducts.length > 0) || (donationProducts && donationProducts.length > 0)) {
                    actionGetMemberValidation(dispatch, memberno, requiredFields1["last_name"], email, phone, address, null);
                }
            }
        }
        else {

            setremoveMembershipState(true);
            actionResetMemberValidation(dispatch);

            if (events && events.length > 0) {
                RemoveCouponsAndGiftCards();
                GetTourEvents();
            }
            if ((membershipPackages && membershipPackages.length > 0) || (gatickets && gatickets.length > 0) || ShowGiftCards() || (orderProducts && orderProducts.length > 0) || (donationProducts && donationProducts.length > 0)) {
                RemoveMembership();
            }
        }
    }

    //Membership Validation End


    //IDme Intregration Start

    useEffect(() => {
        if (events && events.length > 0 && window.location.href.includes('?#access_token=') && window.location.href.includes('token_type') && window.location.href.includes('expires_in')
            && !idmeuserdata.loading && !idmeuserdata.userdata.hasOwnProperty('attributes') && idmeuserdata.userdataerror.length < 1) {

            let indexOfAccessToken = parseInt(window.location.href.indexOf('access_token=')) + 13;
            let idmeAccessToken = window.location.href.substr(indexOfAccessToken, 32);
            actionGetIDMEUSERDATA(dispatch, idmeAccessToken);
        }

        if (events && events.length > 0 && window.location.href.includes('?#error=invalid_scope')) {
            seterrorMsg(IDmeInvalidGroup);
        }

        if (events && events.length > 0 && window.location.href.includes('?#error=unsupported_response_type')) {
            seterrorMsg(IDmeResponseTypeError);
        }

        if (events && events.length > 0 && window.location.href.includes('?#error=invalid_client')) {
            seterrorMsg(IDmeInvalidClient);
        }

        if (events && events.length > 0 && window.location.href.includes('?#error=invalid_redirect_uri')) {
            seterrorMsg(IDmeInvalidRedirectUri);
        }

        if (events && events.length > 0 && window.location.href.includes('?#error=access_denied')) {
            seterrorMsg(IDmeAccessDenied);
        }

    }, [window.location.href]);

    useEffect(() => {

        if (idmeuserdata.userdata &&
            idmeuserdata.userdata.hasOwnProperty('attributes') && idmeuserdata.userdata.hasOwnProperty('status')) {

            let group = '';
            let subgroups = '';

            if (idmeuserdata.userdata.status.length > 0) {
                group = idmeuserdata.userdata.status[0].group;
                subgroups = idmeuserdata.userdata.status[0].subgroups;
            }

            actionGetCostRate(dispatch, group, subgroups);
        }

        if (idmeuserdata.userdataerror.hasOwnProperty('Errors') && idmeuserdata.userdataerror.Errors.length > 0 && errorMsg.length == 0) {
            seterrorMsg(idmeuserdata.userdataerror.Errors[0].ErrorMessage)
        }
    }, [idmeuserdata]);

    useEffect(() => {

        if (costrate.costrate.hasOwnProperty('CostRateID') && costrate.costrate.CostRateID > -1 && shopcartreducer.IDME.idmecostrate !== costrate.costrate.CostRateID
            && costrate.loading === false && !genfunction.IsOrganization(events)) {
            GetTourEvents();
        }

        if (costrate.costraterror.length > 0) {
            seterrorMsg(costrate.costraterror);
        }
    }, [costrate.costrate]);

    useEffect(() => {
        if (costrate.costrate.hasOwnProperty('CostRateID') && costrate.costrate.CostRateID > -1 && shopcartreducer.IDME.isIdMeApplied === false
            && events.length > 0 && !genfunction.IsOrganization(events)) {
            actionShopCartApplyidmeCostratesOnEvents(dispatch, costrate.costrate.CostRateID, tourEvents);
            if (colorState !== 'info') {
                setColorState('info');
                seterrorMsg(IDmeSuccessMsg)
            }
        }

    }, [tourEvents]);

    const ConnectIDME = () => {

        let idmeApiurl = CryptoAES.decrypt(IDmeAPIurl, '1271').toString(CryptoENC);
        let idmeclientID = CryptoAES.decrypt(IDmeClientID, '1271').toString(CryptoENC);

        let idmeurl = idmeApiurl + idmeclientID + '&redirect_uri=' + IDmeRedirectURI + '&response_type=' + IDmeResponseType + '&scopes=' + IDmeScope;
        return idmeurl;
    }

    const ShowIDME = () => {

        let show = false;
        let costrate = DefaultCostRateID;

        if (shopcartreducer.membershipValidation.ismembershipApplied) {
            costrate = shopcartreducer.membershipValidation.membershipcostrate;
        }

        if (shopcartreducer.IDME.isIdMeApplied) {
            costrate = shopcartreducer.IDME.idmecostrate;
        }

        events && events.length > 0 && events.map(e => {
            e.TourProducts.map(prods => {
                if (prods.hasOwnProperty('PriceMatrix') &&
                    prods.PriceMatrix.filter(x => x.CostRateID === costrate && x.VerifyGroupMembership === true).length > 0) {
                    show = true;
                }
            })
        });

        if (show && genfunction.IsOrganization(events)) {
            show = false;
        }

        if (shopcartreducer.IDME.isIdMeApplied) {
            show = false;
        }

        return show && CheckForIDmeValidProducts;
    }

    //IDme Intregration End

    const changeBillingAddress = () => {
        actionSetFieldValueState(dispatch, 'billingAddressSame', !formfields.billingAddressSame.value);
    }
    let displayclass = "";
    if (paymenttranstate.loading)
        displayclass = classes.hidden;
    else if (paymenttranstate.haspaid)
        displayclass = classes.displaynone;



    const GetTransOptionalText = () => {
        let optionalTxt = '';
        if (transactionfee.transactionFee && transactionfee.transactionFee.length > 0) {
            optionalTxt = transactionfee.transactionFee[0].TransactionFeeOptionalText;

            optionalTxt += ' [' + genfunction.ccyFormat(parseFloat(genfunction.TransactionFee(events, donation, transactionfee.transactionFee[0], cashless, membershipPackages, gatickets, giftcards.giftcards, orderProducts, donationProducts))) + ']';
        }

        return optionalTxt;
    }

    let showFreeTicket = ((events && events.length > 0) || (gatickets && gatickets.length > 0) || (membershipPackages && membershipPackages.length > 0) || (orderProducts && orderProducts.length) || (donationProducts && donationProducts.length > 0)) > 0 && genfunction.subproducttotal(events, cashless, donation, (showTransFee ? transactionfee.transactionFee[0] : null), membershipPackages, gatickets, giftcards.giftcards, orderProducts, donationProducts) == 0 ? true : false;

    let memberemailonFile = GetEmailOnFileVal(memberValidationReducer);

    let membershipInCart = membershipPackages && membershipPackages.length > 0 ? true : false;

    return (
        <Card id="pform" className={classes.box100per}>
            <CardHeader className={classes.primarycolor}
                title={PaymentFormHeading}
                titleTypographyProps={{ color: "inherit" }} />
            <CardContent>
                <Grid container>
                    <Grid container item xs={12}>
                        <Grid id="vt_component_checkout_paymentform" container spacing={2} className={displayclass}>
                            <Grid item xs={6}>
                                <TextField
                                    id="Fname"
                                    label="First Name"
                                    name="first_name"
                                    fullWidth={true}
                                    autoFocus
                                    inputRef={inputreferences['first_name']}
                                    error={errorstate.first_name.errorstate}
                                    helperText={errorstate.first_name.errortext}
                                    onChange={fieldhandleChange}
                                    value={formfields.first_name.value}
                                    inputProps={{ maxLength: AddPersonFirstNameLength }}
                                    disabled={membershipInCart}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    id="Lname"
                                    label="Last Name"
                                    name="last_name"
                                    fullWidth={true}
                                    inputRef={inputreferences['last_name']}
                                    error={errorstate.last_name.errorstate}
                                    helperText={errorstate.last_name.errortext}
                                    onChange={fieldhandleChange}
                                    value={formfields.last_name.value}
                                    inputProps={{ maxLength: AddPersonLastNameLength }}
                                    disabled={membershipInCart}
                                />
                            </Grid>
                            <Grid item md={HideMemberValidation === true || genfunction.IsOrganization(events) ? 12 : 8} sm={HideMemberValidation === true || genfunction.IsOrganization(events) ? 12 : 8} xs={12} >
                                <TextField
                                    id="Email"
                                    label="Email"
                                    name="email"
                                    fullWidth={true}
                                    inputRef={inputreferences['email']}
                                    error={errorstate.email.errorstate}
                                    helperText={errorstate.email.errortext}
                                    type="email"
                                    onChange={fieldhandleChange}
                                    value={formfields.email.value}
                                    inputProps={{ maxLength: AddPersonEmailLength, "data-hj-allow": "" }}
                                    disabled={membershipInCart}

                                />
                            </Grid>
                            {HideMemberValidation === false && !genfunction.IsOrganization(events) ?
                                <Grid item md={4} sm={4} xs={12} className={classes.imMember}>
                                    <Checkbox
                                        id="chkimMember"
                                        name="checkBoxMember"
                                        color="primary"
                                        size="small"
                                        checked={formfields.checkBoxMember.value}
                                        onChange={fieldhandleChange}
                                        inputProps={{ 'aria-label': 'secondary checkbox' }}
                                    />
                                    <Typography color="textSecondary" component="span" >
                                        {IamMember}
                                    </Typography>
                                </Grid> : null}

                            {formfields.checkBoxMember.value ?
                                <Grid item md={10} sm={9} xs={9}>
                                    <TextField
                                        id="memberno"
                                        name="memberno"
                                        label="Member #"
                                        inputRef={inputreferences['memberno']}
                                        fullWidth={true}
                                        error={errorstate.memberno.errorstate}
                                        helperText={errorstate.memberno.errortext}
                                        onChange={fieldhandleChange}
                                        value={formfields.memberno.value}
                                    />
                                </Grid> : null}
                            {formfields.checkBoxMember.value ?
                                <Grid item md={2} sm={3} xs={3}>
                                    <Button className={classes.btnAlign}
                                        size="medium" variant="contained"
                                        color="primary"
                                        id="btnApplyMembership"
                                        name={shopcartreducer.membershipValidation.ismembershipApplied ? 'Remove' : 'Apply'}
                                        onClick={() => { MemberValidation(formfields.memberno.value) }}
                                    >{shopcartreducer.membershipValidation.ismembershipApplied ? 'Remove' : 'Apply'}</Button>
                                </Grid> : null}

                            {ShowIDME() ?
                                <Grid item xs={12} align="center">
                                    <div id="idme-verification">
                                        <Typography variant="body1">{IDmeHeading}</Typography>
                                        <a href={ConnectIDME()}>
                                            <img src="https://s3.amazonaws.com/idme/developer/idme-buttons/assets/img/verify.svg" height="50" />
                                        </a>
                                        <p>
                                            <Typography variant="body1"> <img src="https://developers.id.me/assets/buttons/lock-icon-a5b18fbb34d393a80967c08399786f95955ee818b693b97d3f37698e2bc113f2.svg" height="10" />
                                                Verification by ID.me •
                                                <a href="https://www.id.me/about" target='_new'>What is ID.me?</a>
                                            </Typography>
                                        </p>
                                    </div>
                                </Grid>
                                : null}

                            <Grid item xs={12}>
                                <TextField
                                    id="phone_number"
                                    name="phone_number"
                                    label={(PhoneNumberMandatory || (orderProducts && orderProducts.length > 0)) ? "Phone #" : "Phone # (Optional)"}
                                    onChange={fieldhandleChange}
                                    value={formfields.phone_number.value}
                                    inputRef={inputreferences['phone_number']}
                                    fullWidth={true}

                                    error={errorstate.phone_number.errorstate}
                                    helperText={errorstate.phone_number.errortext}
                                    InputProps={{
                                        inputComponent: TextMaskCustom,
                                        inputMode: 'numeric', pattern: '[0-9]*'
                                    }}
                                    disabled={membershipInCart}
                                >
                                </TextField>
                            </Grid>


                            {ShowFullAddressOnCheckout ?
                                <>
                                    <Grid item xs={12} md={12}>

                                        {genfunction.IsObjectNotNullOrEmptyOrUndefined(countryandstates) ?

                                            <FormControl className={classes.box100per} error={errorstate.country.errorstate}>
                                                <Autocomplete filterOptions={filterOptions}
                                                    id="country"
                                                    name="country"
                                                    options={countryandstates}
                                                    fullWidth={true}
                                                    onChange={onChangeCountry}
                                                    autoHighlight
                                                    getOptionLabel={(option) => {
                                                        if (option.hasOwnProperty('Country')) {
                                                            return option.Country;
                                                        }
                                                        return option;
                                                    }}
                                                    value={formfields.country.value}
                                                    //   defaultValue={ countryandstates[0]}
                                                    renderOption={(option) => (
                                                        <>
                                                            <img
                                                                loading="lazy"
                                                                width="40"
                                                                src={`https://flagcdn.com/w40/${option.ISOCode}.png`}
                                                                srcSet={`https://flagcdn.com/w80/${option.ISOCode}.png 2x`}
                                                                alt=""
                                                                style={{ margin: "10px" }}
                                                            />
                                                            {` ${option.Country} `}</>
                                                    )}

                                                    style={{ width: "100%" }}
                                                    renderInput={(params) =>
                                                    (<TextField inputRef={inputreferences['country']} label="Country" variant='outlined' className={classes.clearButton}{...params}
                                                    />
                                                    )}
                                                    disabled={membershipInCart}
                                                />
                                                <FormHelperText>{errorstate.country.errortext}</FormHelperText>
                                            </FormControl>
                                            : ""}

                                    </Grid>

                                    <Grid item xs={12}>
                                        <TextField
                                            id="address1"
                                            name="address1"
                                            label="Address 1"
                                            inputRef={inputreferences['address1']}
                                            fullWidth={true}
                                            error={errorstate.address1.errorstate}
                                            helperText={errorstate.address1.errortext}
                                            onChange={fieldhandleChange}
                                            value={formfields.address1.value}
                                            inputProps={{ maxLength: AddPersonAddress1Length }}
                                            disabled={membershipInCart}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            id="address2"
                                            name="address2"
                                            label="Address 2 (Optional)"
                                            fullWidth={true}
                                            error={errorstate.address2.errorstate}
                                            helperText={errorstate.address2.errortext}
                                            onChange={fieldhandleChange}
                                            value={formfields.address2.value}
                                            inputProps={{ maxLength: AddPersonAddress2Length }}
                                            disabled={membershipInCart}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={12}>
                                        <TextField
                                            id="city"
                                            label={isShowCountryFields("CityText")}
                                            name="city"
                                            inputRef={inputreferences['city']}
                                            fullWidth={true}
                                            error={errorstate.city.errorstate}
                                            helperText={errorstate.city.errortext}
                                            onChange={fieldhandleChange}
                                            value={formfields.city.value}
                                            inputProps={{ maxLength: AddPersonCityLength }}
                                            disabled={membershipInCart}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={isShowCountryFields("ShowPostalCode") ? 6 : 12}>

                                        {genfunction.IsObjectNotNullOrEmptyOrUndefined(countryandstates) && isShowCountryFields("ShowState") ?

                                            <FormControl className={classes.box100per} error={errorstate.state.errorstate}>
                                                <Autocomplete filterOptions={filterOptions}
                                                    id="state"
                                                    name="state"
                                                    autoHighlight
                                                    options={
                                                        formfields.country.value ? countryandstates.filter(
                                                            x => x.Country == formfields.country.value).map(o => o.hasOwnProperty("Picklist") ? o.Picklist : [])[0]
                                                            : []
                                                    }
                                                    fullWidth={true}
                                                    onChange={onChangeState}
                                                    getOptionLabel={(option) => {
                                                        if (option.hasOwnProperty('State')) {
                                                            return option.State;
                                                        }
                                                        return option;
                                                    }}
                                                    value={formfields.state.value}

                                                    style={{ width: "100%" }}
                                                    renderInput={(params) =>
                                                    (<TextField inputRef={inputreferences['state']} label="State" variant='outlined' className={classes.clearButton}{...params}
                                                    />
                                                    )}
                                                    disabled={membershipInCart}
                                                />
                                                <FormHelperText>{errorstate.state.errortext}</FormHelperText>
                                            </FormControl>
                                            : ""}

                                    </Grid>
                                </>
                                : ""}


                            < Grid item xs={12} md={isShowCountryFields("ShowState") ? 6 : 12}>
                                {isShowCountryFields("ShowPostalCode") == true ?
                                    <TextField
                                        id="zip"
                                        label={isShowCountryFields("PostalCodeName")}
                                        name="zip"
                                        inputRef={inputreferences['zip']}
                                        fullWidth={true}
                                        error={errorstate.zip.errorstate}
                                        helperText={errorstate.zip.errortext}
                                        onChange={fieldhandleChange}
                                        value={formfields.zip.value}
                                        inputProps={{ maxLength: AddPersonZipCodeLength }}
                                        disabled={membershipInCart}
                                    />
                                    : ""}
                            </Grid>


                            {ShowFullAddressOnCheckout ?
                                <>
                                    <Grid item xs={12}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                                    name="checkboxBillingAddress"
                                                    color="primary"
                                                    onChange={() => changeBillingAddress()}
                                                    checked={formfields.billingAddressSame.value}
                                                    disabled={membershipInCart}
                                                />
                                            }
                                            label="Billing Address same as above"
                                        />
                                    </Grid>
                                    {formfields.billingAddressSame.value == false ?
                                        <>
                                            <Grid item xs={12}>
                                                <Typography variant="h4">Billing Address</Typography>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <TextField
                                                    id="shipping_phone_number"
                                                    name="shipping_phone_number"
                                                    label={(PhoneNumberMandatory || (orderProducts && orderProducts.length > 0)) ? "Phone #" : "Phone # (Optional)"}
                                                    inputRef={inputreferences['shipping_phone_number']}
                                                    onChange={fieldhandleChange}
                                                    value={formfields.shipping_phone_number.value}
                                                    fullWidth={true}
                                                    error={errorstate.shipping_phone_number.errorstate}
                                                    helperText={errorstate.shipping_phone_number.errortext}
                                                    InputProps={{
                                                        inputComponent: TextMaskCustom,
                                                        inputMode: 'numeric', pattern: '[0-9]*'
                                                    }}
                                                    disabled={membershipInCart}
                                                >
                                                </TextField>
                                            </Grid>
                                            <Grid item xs={12} md={12}>

                                                {genfunction.IsObjectNotNullOrEmptyOrUndefined(countryandstates) ?

                                                    <FormControl className={classes.box100per} error={errorstate.shipping_country.errorstate}>
                                                        <Autocomplete filterOptions={filterOptions}
                                                            id="shipping_country"
                                                            name="shipping_country"
                                                            options={countryandstates}
                                                            fullWidth={true}
                                                            onChange={onChangeShippingCountry}
                                                            autoHighlight
                                                            getOptionLabel={(option) => {
                                                                if (option.hasOwnProperty('Country')) {
                                                                    return option.Country;
                                                                }
                                                                return option;
                                                            }}
                                                            value={formfields.shipping_country.value}
                                                            renderOption={(option) => (
                                                                <>
                                                                    <img
                                                                        loading="lazy"
                                                                        width="40"
                                                                        src={`https://flagcdn.com/w40/${option.ISOCode}.png`}
                                                                        srcSet={`https://flagcdn.com/w80/${option.ISOCode}.png 2x`}
                                                                        alt=""
                                                                        style={{ margin: "10px" }}
                                                                    />
                                                                    {` ${option.Country} `}</>
                                                            )}

                                                            style={{ width: "100%" }}
                                                            renderInput={(params) =>
                                                            (<TextField inputRef={inputreferences['shipping_country']} label="Country" variant='outlined' className={classes.clearButton}{...params}
                                                            />
                                                            )}
                                                            disabled={membershipInCart}
                                                        />
                                                        <FormHelperText>{errorstate.shipping_country.errortext}</FormHelperText>
                                                    </FormControl>
                                                    : ""}

                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    id="shipping_address1"
                                                    name="shipping_address1"
                                                    label="Address 1"
                                                    inputRef={inputreferences['shipping_address1']}
                                                    fullWidth={true}
                                                    error={errorstate.shipping_address1.errorstate}
                                                    helperText={errorstate.shipping_address1.errortext}
                                                    onChange={fieldhandleChange}
                                                    value={formfields.shipping_address1.value}
                                                    inputProps={{ maxLength: AddPersonAddress1Length }}
                                                    disabled={membershipInCart}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    id="shipping_address2"
                                                    name="shipping_address2"
                                                    label="Address 2 (Optional)"
                                                    fullWidth={true}
                                                    error={errorstate.shipping_address2.errorstate}
                                                    helperText={errorstate.shipping_address2.errortext}
                                                    onChange={fieldhandleChange}
                                                    value={formfields.shipping_address2.value}
                                                    inputProps={{ maxLength: AddPersonAddress2Length }}
                                                    disabled={membershipInCart}
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={12}>
                                                <TextField
                                                    id="shipping_city"
                                                    label={isShowShippingCountryFields("CityText")}
                                                    name="shipping_city"
                                                    inputRef={inputreferences['shipping_city']}
                                                    fullWidth={true}
                                                    error={errorstate.shipping_city.errorstate}
                                                    helperText={errorstate.shipping_city.errortext}
                                                    onChange={fieldhandleChange}
                                                    value={formfields.shipping_city.value}
                                                    inputProps={{ maxLength: AddPersonCityLength }}
                                                    disabled={membershipInCart}
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={isShowShippingCountryFields("ShowPostalCode") ? 6 : 12}>

                                                {genfunction.IsObjectNotNullOrEmptyOrUndefined(countryandstates) && isShowShippingCountryFields("ShowState") ?

                                                    <FormControl className={classes.box100per} error={errorstate.shipping_state.errorstate}>

                                                        <Autocomplete filterOptions={filterOptions}
                                                            id="shipping_state"
                                                            name="shipping_state"
                                                            autoHighlight
                                                            options={
                                                                formfields.shipping_country.value ? countryandstates.filter(
                                                                    x => x.Country == formfields.shipping_country.value).map(o => o.hasOwnProperty("Picklist") ? o.Picklist : [])[0]
                                                                    : []
                                                            }
                                                            fullWidth={true}
                                                            onChange={onChangeShippingState}
                                                            getOptionLabel={(option) => {
                                                                if (option.hasOwnProperty('State')) {
                                                                    return option.State;
                                                                }
                                                                return option;
                                                            }}
                                                            value={formfields.shipping_state.value}
                                                            style={{ width: "100%" }}
                                                            renderInput={(params) =>
                                                            (<TextField inputRef={inputreferences['shipping_state']} label="State" variant='outlined' className={classes.clearButton}{...params}
                                                            />
                                                            )}
                                                            disabled={membershipInCart}
                                                        />
                                                        <FormHelperText>{errorstate.shipping_state.errortext}</FormHelperText>
                                                    </FormControl>
                                                    : ""}


                                            </Grid>

                                            <Grid item xs={12} md={isShowShippingCountryFields("ShowState") ? 6 : 12}>
                                                {isShowShippingCountryFields("ShowPostalCode") ?
                                                    <TextField
                                                        id="shipping_zip"
                                                        label={isShowShippingCountryFields("PostalCodeName")}
                                                        name="shipping_zip"
                                                        inputRef={inputreferences['shipping_zip']}
                                                        fullWidth={true}
                                                        error={errorstate.shipping_zip.errorstate}
                                                        helperText={errorstate.shipping_zip.errortext}
                                                        onChange={fieldhandleChange}
                                                        value={formfields.shipping_zip.value}
                                                        inputProps={{ maxLength: AddPersonZipCodeLength }}
                                                        disabled={membershipInCart}
                                                    />
                                                    : ""}
                                            </Grid>
                                        </>
                                        : null}
                                </> : ""}
                            {showFreeTicket ? <FreeTicketForm /> : null}
                            <Grid container item spacing={2} className={(showFreeTicket && PaymentMethodType === "Spreedly") || paymenttranstate.loading ? classes.displaynone : classes.visible} >

                                <Grid item xs={12}>
                                    <Payments type={PaymentMethodType}
                                        ref={paymentsRef} ValidatePaymentFields={ValidatePaymentFields}
                                        showFreeTkt={showFreeTicket}
                                        managemyBooking={false}
                                        AdditionBooking={false}
                                    />
                                </Grid>
                            </Grid>


                            {PaymentMethodType === "Spreedly" ?
                                <>
                                    {ApplyTransactionFee && transFeeCheckBox() === true && showFreeTicket === false ?
                                        < Grid item xs={12}>
                                            <Checkbox
                                                color="primary"
                                                checked={showTransFee}
                                                onChange={transFeeCheckHandler}
                                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                            />
                                            <Typography color="textSecondary" component="span" >
                                                {GetTransOptionalText()}
                                            </Typography>
                                        </Grid>
                                        : null}

                                    < Grid item xs={12}>
                                        <Checkbox
                                            color="primary"
                                            checked={tncchecked}
                                            onChange={tnccheckeHandle}
                                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                                        />
                                        <Typography color="textSecondary" component="span" >
                                            {TermsnConditionCheckBoxText}
                                            <Link href="#" onClick={() => { setopentnc(true) }} > Terms and Conditions </Link>
                                        </Typography>

                                    </Grid>
                                    <Grid item xs={12}>
                                        {tncchecked && EnableAlternateMerchantOnline && !showFreeTicket && (orderProducts && orderProducts.length < 1) ? <MultiPayments /> : null}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Button

                                            disabled={pfstate.disablepay ||
                                                ((genfunction.subproducttotal(events, cashless, donation, (showTransFee ? transactionfee.transactionFee[0] : null), membershipPackages, gatickets, giftcards.giftcards, orderProducts, donationProducts) > 0)
                                                    && errorstate.cvv.errorstate) || onClickPayBtn.isPending()
                                                || stopUserToPurchase === true}
                                            className={classes.primarycolor + " " + classes.box100per}
                                            onClick={onClickPayBtn}
                                        >Pay</Button>
                                    </Grid> </> : null}

                        </Grid>
                        <ProcessingBox isshow={paymenttranstate.loading} title={Titleforloadingpayment} text1={Subtitle1forloadingpayment} text2={Subtitle2forloadingpayment} ></ProcessingBox>
                        <PaymentCompletebox isshow={paymenttranstate.haspaid} onClickHandler={onClickPaymentHandler} transaction={paymenttranstate.paymentinfo} ></PaymentCompletebox>
                        <ErrorHandling color={colorState} msg={paymenttranstate.errormsg != "" ? paymenttranstate.errormsg : errorMsg} open={openerrorpopup()} handleclose={errorcancelhandle} />
                        <DialogeBox open={opentnc} title={"Terms and Conditions"}
                            message={getTNC()}
                            button1text={"Close"}
                            button1clickhandler={() => { setopentnc(false) }}></DialogeBox>
                        <Dialog
                            open={open}
                            onClose={handleCloseDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                            disableEscapeKeyDown={false}
                            disableBackdropClick={false}
                        >
                            <DialogTitle id="alert-dialog-title">{"Confirmation"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Email does not match. Email on file is {memberemailonFile}. Would you like to use this email or update the email address on file?
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button id="1" name={memberemailonFile} onClick={handleCloseDialog} color="primary">
                                    Use {memberemailonFile}
                                </Button>
                                <Button id="2" name={formfields.email.value} onClick={handleCloseDialog} color="primary" autoFocus>
                                    Update my record to use {formfields.email.value}.
                                </Button>
                            </DialogActions>
                        </Dialog>

                    </Grid>
                </Grid>
            </CardContent>

        </Card >

    );

});

export default PaymentForm;

function GetEmailOnFileVal(memberValidationReducer) {
    return memberValidationReducer.membervalidation !== undefined
        && memberValidationReducer.membervalidation.MemberValidation !== undefined
        && memberValidationReducer.membervalidation.MemberValidation[0] !== undefined
        && memberValidationReducer.membervalidation.MemberValidation[0].hasOwnProperty("EmailOnFile") ?
        memberValidationReducer.membervalidation.MemberValidation[0].EmailOnFile : '';
}

